/** Here is the typical component from react being rendered for the corresponding form*/
import React from "react";
import EntityForm from "../EntityForm/EntityForm";
import "./customStyles.css";
import CancellationPolicyConfigurationList from "./CancellationPolicyConfiguration/CancellationPolicyConfigurationList";
import CancellationPolicyConfigurationForm from "./CancellationPolicyConfiguration/CancellationPolicyConfigurationForm";
import { entityToFormValuesMapper } from "../../Common/utils";
import CONSTANTS from "../constants";
import asBookingEngineEntity from "../Common/BookingEngineEntityHOC";
import { defineMessages, injectIntl } from "react-intl";

const messages = defineMessages({
  bothOrNone: {
    id: "app.cancellationPolicies.bothOrNone",
    description: "Both the start date and the end date must be present",
    defaultMessage: "Both the start date and the end date must be present",
  },
});
/** this function is called when the JSON will be written at the corresponding field*/
function customEntityToFormValuesMapper({ entity, fields, locales, translationConfig }) {
  const formValues = entityToFormValuesMapper({
    entity,
    fields,
    locales,
    translationConfig,
  });

  const propertyTicker = entity.propertyTicker || entity.hotelTicker;

  return {
    ...formValues,
    propertyTicker,
  };
}

function isReleaseCreated(release) {
  if (release && typeof release !== "object") {
    return { duration: release, chronoUnit: "DAYS" };
  } else if ((release && !release.duration === undefined) || !release) {
    return undefined;
  }
  return release;
}

class CancellationPolicyForm extends React.Component {
  static nestedFomWidgets = {
    /** here is where the nested entity links with the fieldName declared at the module definition, also the corresponding form and list must be imported*/
    configurations: asBookingEngineEntity(CancellationPolicyConfigurationForm, {
      entityName: CONSTANTS.ENTITY.CANCELLATIONPOLICYCONFIGURATION.name,
      type: "FORM",
    }),
  };

  static nestedListWidgets = {
    configurations: asBookingEngineEntity(CancellationPolicyConfigurationList, {
      entityName: CONSTANTS.ENTITY.CANCELLATIONPOLICYCONFIGURATION.name,
      type: "LIST",
    }),
  };

  getFields(fields) {
    return fields && fields.form;
  }
  /** this function is called when the fields will be written at the JSON*/
  handleSubmit = ({ formValues }) => {
    console.log("submitted ");
    //TODO: handle case when there's an original entity
    //TODO: this could be handled in a generic way.
    const { id, ...otherFormValues } = formValues;
    const entity = {
      ...otherFormValues,
    };

    entity.configurations.forEach(value => {
      value.minRelease = isReleaseCreated(value.minRelease);
      value.maxRelease = isReleaseCreated(value.maxRelease);
      if (!value.minReleaseTimeLimit) {
        delete value.minReleaseTimeLimit;
      }
      if (!value.maxReleaseTimeLimit) {
        delete value.maxReleaseTimeLimit;
      }
      if (value?.minRelease && (value?.minRelease?.duration === undefined || value?.minRelease?.duration === null)) {
        delete value.minRelease;
      }
      if (value?.maxRelease && (value?.maxRelease?.duration === undefined || value?.minRelease?.duration === null)) {
        delete value.maxRelease;
      }
    });

    if (id !== "" && id !== " " && id !== null && typeof formValues.id !== "undefined") {
      entity.id = formValues.id;
    }

    if (entity.validFrom === "" && entity.validTo === "") {
      entity.validFrom = undefined;
      entity.validTo = undefined;
    }

    this.props.onSubmitEntity({
      entity,
    });
  };

  customValidate = formValues => {
    if (
      (formValues.validFrom && !formValues.validTo) ||
      (formValues.validTo && !formValues.validFrom)
    ) {
      return this.props.intl.formatMessage(messages.bothOrNone);
    }
    return "";
  };

  /* Handle Errors */
  render() {
    const { name, validation, fields, renderers, translation, entities } = this.props.config;
    const {
      locales,
      entity,
      entityError,
      entityResult,
      entityName,
      loading,
      getListPath,
    } = this.props;

    const { getFields, handleSubmit } = this;
    return (
      <div className={"wbkv9-form-cancellationPolicy"}>
        <EntityForm
          loading={loading}
          name={name}
          entity={entity}
          entities={entities}
          validation={validation}
          renderers={renderers}
          fields={getFields(fields)}
          locales={locales}
          translation={translation}
          onSubmit={handleSubmit}
          customValidate={this.customValidate}
          entityError={entityError}
          entityResult={entityResult}
          entityName={entityName}
          getListPath={getListPath}
          nestedFormWidgets={CancellationPolicyForm.nestedFomWidgets}
          nestedListWidgets={CancellationPolicyForm.nestedListWidgets}
          entityToFormValuesMapper={customEntityToFormValuesMapper}
        />
      </div>
    );
  }
}

CancellationPolicyForm.propTypes = {};

CancellationPolicyForm.defaultProps = {
  locales: ["es", "ca", "en", "fr", "it", "de"],
};

export default injectIntl(CancellationPolicyForm);
